// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wallet_btnGroup {
    width: 300px;
    height: 50px;
    border-radius: 10px;
    background-color: #e84427;
    display: flex;
    align-items: center;
    justify-content: space-around;
    gap: 10px;
    padding: 5px;
    margin-top: 10px;
  }
  
  .walt_add {
    background: #ffffff;
    border-radius: 8px;
    width: 112px;
    height: 46px;
    color: #000000;
    font-size: 18px;
    outline: none;
    border: none;
    font-weight: 600;
  }
  
  .wallet_btnGroup>button:first-child {
    background-color: transparent;
    border: none;
    outline: none;
    color: #ffffff;
    font-weight: 600;
    flex-grow: 1;
  }
  
  .drop-container {
    width: 238px;
    height: 50px;
    background-color: #c8c7c7;
    border-radius: 7px 6px 8px 8px;
    position: absolute;
    top: 71px;
    right: 25px;
    display: flex;
    z-index: -1;
    align-items: center;
    justify-content: space-around;
    cursor: pointer;
  }
  
  .drop-container>span {
    color: #000000;
    font-weight: 600;
  }
  
  .drop-container>img {
    height: 1rem;
    width: 1rem;
  }
  
  .filter_drop_box2>.dropdown-menu {
    min-width: 100%;
  }
  
  .dis-wallet {
    cursor: pointer;
  }
  
  .w3m-modal {
    z-index: 999999 !important;
  }
  
  .wallet-connect-btn {
    width: 11em;
    height: 40px;
    font-size: 20px;
    display: flex;
    gap: 1.2rem;
    align-items: center;
    justify-content: center;
    box-shadow: 0px 4px 4px 0px #00000040;
    border-radius: 20px;
    border: 2px solid transparent;
    background: linear-gradient(90deg, #E84427, #E84427, #E84427) padding-box, linear-gradient(180deg, #ED1C24 0%, #FFFFFF 100%) border-box;
    color: #fff;
  }
  
  .wallet-connect-btn:hover {
    color: #000;
    background: #fff;
    border: 3px solid #E84427;
    font-weight: 600;
  }
  
  .wallet-connect-btn-blue{
    width: 11em;
    height: 40px;
    font-size: 20px;
    display: flex;
    gap: 1.2rem;
    align-items: center;
    justify-content: center;
    box-shadow: 0px 4px 4px 0px #00000040;
    border-radius: 20px;
    border: 2px solid transparent;
    background: linear-gradient(90deg, #234B9A, #234B9A, #234B9A) padding-box, linear-gradient(180deg, #234B9A 0%, #FFFFFF 100%) border-box;
    color: #fff;
  }
  
  .wallet-connect-btn-blue:hover {
    color: #234B9A;
    background: #fff;
    border: 3px solid #234B9A;
    font-weight: 600;
  }

  .wallet_btnGroup_blue {
    background-color: #234B9A;
  }
  
  @media screen and (max-width: 475px) {
    .wallet_btnGroup {
      width: 120px;
    }
  
    .walt_add {
      width: 94px;
      height: 43px;
      font-size: 11px;
    }
  
    .wallet_btnGroup>button:first-child {
      font-size: 11px;
    }
  
    .filter_drop_box2>.dropdown-menu {
      font-size: 14px;
    }
  
  }
  
  @media screen and (max-width: 370px) {
    .wallet-connect-btn {
      font-size: 13px !important;
      width: 120px !important;
    }
  }`, "",{"version":3,"sources":["webpack://./src/Utils/wallet/WalletConnectBtn.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,SAAS;IACT,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,cAAc;IACd,eAAe;IACf,aAAa;IACb,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,6BAA6B;IAC7B,YAAY;IACZ,aAAa;IACb,cAAc;IACd,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,8BAA8B;IAC9B,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,6BAA6B;IAC7B,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;IACrC,mBAAmB;IACnB,6BAA6B;IAC7B,uIAAuI;IACvI,WAAW;EACb;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;IACrC,mBAAmB;IACnB,6BAA6B;IAC7B,uIAAuI;IACvI,WAAW;EACb;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE;MACE,YAAY;IACd;;IAEA;MACE,WAAW;MACX,YAAY;MACZ,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;EAEF;;EAEA;IACE;MACE,0BAA0B;MAC1B,uBAAuB;IACzB;EACF","sourcesContent":[".wallet_btnGroup {\n    width: 300px;\n    height: 50px;\n    border-radius: 10px;\n    background-color: #e84427;\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n    gap: 10px;\n    padding: 5px;\n    margin-top: 10px;\n  }\n  \n  .walt_add {\n    background: #ffffff;\n    border-radius: 8px;\n    width: 112px;\n    height: 46px;\n    color: #000000;\n    font-size: 18px;\n    outline: none;\n    border: none;\n    font-weight: 600;\n  }\n  \n  .wallet_btnGroup>button:first-child {\n    background-color: transparent;\n    border: none;\n    outline: none;\n    color: #ffffff;\n    font-weight: 600;\n    flex-grow: 1;\n  }\n  \n  .drop-container {\n    width: 238px;\n    height: 50px;\n    background-color: #c8c7c7;\n    border-radius: 7px 6px 8px 8px;\n    position: absolute;\n    top: 71px;\n    right: 25px;\n    display: flex;\n    z-index: -1;\n    align-items: center;\n    justify-content: space-around;\n    cursor: pointer;\n  }\n  \n  .drop-container>span {\n    color: #000000;\n    font-weight: 600;\n  }\n  \n  .drop-container>img {\n    height: 1rem;\n    width: 1rem;\n  }\n  \n  .filter_drop_box2>.dropdown-menu {\n    min-width: 100%;\n  }\n  \n  .dis-wallet {\n    cursor: pointer;\n  }\n  \n  .w3m-modal {\n    z-index: 999999 !important;\n  }\n  \n  .wallet-connect-btn {\n    width: 11em;\n    height: 40px;\n    font-size: 20px;\n    display: flex;\n    gap: 1.2rem;\n    align-items: center;\n    justify-content: center;\n    box-shadow: 0px 4px 4px 0px #00000040;\n    border-radius: 20px;\n    border: 2px solid transparent;\n    background: linear-gradient(90deg, #E84427, #E84427, #E84427) padding-box, linear-gradient(180deg, #ED1C24 0%, #FFFFFF 100%) border-box;\n    color: #fff;\n  }\n  \n  .wallet-connect-btn:hover {\n    color: #000;\n    background: #fff;\n    border: 3px solid #E84427;\n    font-weight: 600;\n  }\n  \n  .wallet-connect-btn-blue{\n    width: 11em;\n    height: 40px;\n    font-size: 20px;\n    display: flex;\n    gap: 1.2rem;\n    align-items: center;\n    justify-content: center;\n    box-shadow: 0px 4px 4px 0px #00000040;\n    border-radius: 20px;\n    border: 2px solid transparent;\n    background: linear-gradient(90deg, #234B9A, #234B9A, #234B9A) padding-box, linear-gradient(180deg, #234B9A 0%, #FFFFFF 100%) border-box;\n    color: #fff;\n  }\n  \n  .wallet-connect-btn-blue:hover {\n    color: #234B9A;\n    background: #fff;\n    border: 3px solid #234B9A;\n    font-weight: 600;\n  }\n\n  .wallet_btnGroup_blue {\n    background-color: #234B9A;\n  }\n  \n  @media screen and (max-width: 475px) {\n    .wallet_btnGroup {\n      width: 120px;\n    }\n  \n    .walt_add {\n      width: 94px;\n      height: 43px;\n      font-size: 11px;\n    }\n  \n    .wallet_btnGroup>button:first-child {\n      font-size: 11px;\n    }\n  \n    .filter_drop_box2>.dropdown-menu {\n      font-size: 14px;\n    }\n  \n  }\n  \n  @media screen and (max-width: 370px) {\n    .wallet-connect-btn {\n      font-size: 13px !important;\n      width: 120px !important;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
